// Module
var code = `<form-section-field field-title="'Product availability'">
  <select
    ng-model="\$ctrl.productAvailability"
    ng-options="o.value as o.label for o in \$ctrl.productAvailabilityModes"
    ng-required="true">
  </select>
</form-section-field>
<form-section-field field-title="'Available in branches'" ng-if="\$ctrl.productAvailability === \$ctrl.productAvailabilityModes.selectedBranches.value">
  <multiselect items="\$ctrl.branchesToSelect"
               select-all-option="true"
               label-property="'name'"
               value-property="'id'"
               ng-model="\$ctrl.availableInBranchIds"
               ng-required="true">
  </multiselect>
</form-section-field>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/common/product/product-availability/product-availability.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;